"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFormIngredients = void 0;
exports.toFormIngredients = (x) => x.map(ig => {
    if (ig.__typename === "RegularIngredient") {
        return {
            sid: ig.sid,
            keyword: ig.keyword,
            editedByUser: ig.editedByUser,
            name: ig.name,
            amount: ig.amount,
            unit: ig.unit,
        };
    }
    else if (ig.__typename === "RecipeLink") {
        return {
            recipeId: ig.recipeId,
            name: ig.name,
            unit: ig.unit,
            amount: ig.amount,
        };
    }
    else {
        return {
            text: ig.text,
        };
    }
});
//# sourceMappingURL=toFormIngredients.js.map